import { render, staticRenderFns } from "./TableForm16.vue?vue&type=template&id=0b99e0d7&scoped=true"
import script from "./TableForm16.vue?vue&type=script&lang=ts"
export * from "./TableForm16.vue?vue&type=script&lang=ts"
import style0 from "./TableForm16.vue?vue&type=style&index=0&id=0b99e0d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99e0d7",
  null
  
)

export default component.exports